import { h } from '@debbie/cortex/dist/index.js';
import { useTransactionAccounts } from '@debbie/cortex/dist/transaction-accounts/index.js';
import React from 'react';
const TransactionAccountPreview = (props) => {
    const transactionAccountsLoadable = useTransactionAccounts();
    const transactionAccounts = h.hasData(transactionAccountsLoadable)
        ? transactionAccountsLoadable.data
        : null;
    const transactionAccount = transactionAccounts?.find((_transactionAccount) => _transactionAccount.transactionAccountId === props.transactionAccountId);
    return React.createElement(React.Fragment, null, transactionAccount?.name);
};
export default TransactionAccountPreview;
//# sourceMappingURL=TransactionAccountPreview.js.map